





























import {Component, Vue} from "vue-property-decorator";
import {AuthService, ILoginRequest} from "../services/auth.service";
import {HashMap} from "../services/base.service";

@Component({
    name: "Login"
})
export default class Login extends Vue {
    private auth!: AuthService;
    private request!: ILoginRequest;
    private loading = false;
    private initialized = false;

    private success = false;
    private error: string | null = null;

    private clear() {
        this.request = {
            email: "",
            password: "",
        }
    }

    private mounted() {
        this.clear();
        this.auth = new AuthService();
        this.initialized = true;
        console.log(document.referrer);
    }

    private async submit() {
        this.loading = true;
        this.error = null;

        const response = await this.auth.login(this.request);

        if (response.success) {
            this.success = true;
            this.$router.go(-1);
        } else {
            this.error = response.error;
        }

        this.loading = false;
    }
}
